// components/Molecules/SocialLink/SocialLink.js
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../Atoms';

/**
 * SocialLink - Social media link with icon
 * 
 * Simple link component for social media platforms.
 * Renders an icon with proper accessibility and external link behavior.
 * 
 * Usage:
 *   <SocialLink 
 *     platform="Twitter" 
 *     url="https://twitter.com/username"
 *     icon={<TwitterIcon />}
 *   />
 */

const SocialLink = ({ 
  platform,
  url,
  icon,
  ariaLabel
}) => (
  <Link 
    href={url} 
    className="inline-flex items-center justify-center p-2 rounded-full transition-colors hover:bg-neutralLight focus:bg-neutralLight focus:outline-none focus:ring-2 focus:ring-primary"
    aria-label={ariaLabel || platform}
    target="_blank"
    rel="noopener noreferrer"
  >
    {icon}
  </Link>
);

SocialLink.propTypes = {
  platform: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
};

export default SocialLink;